import { useEffect } from 'react';
import { buildGoogleFontsUrl, DEFAULT_TYPOGRAPHY, fontStack } from '../../utils/googleFonts';
import { useSettings } from '../../providers/SettingsContext';

const LINK_ID = 'rem-google-fonts-config';

export const applyTypography = (typography = DEFAULT_TYPOGRAPHY) => {
  const nextTypography = {
    ...DEFAULT_TYPOGRAPHY,
    ...typography
  };
  const fontsUrl = buildGoogleFontsUrl([
    nextTypography.bodyFont,
    nextTypography.headingFont,
    nextTypography.accentFont
  ]);

  let fontLink = document.getElementById(LINK_ID);
  if (!fontLink) {
    fontLink = document.createElement('link');
    fontLink.id = LINK_ID;
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);
  }

  if (fontsUrl && fontLink.href !== fontsUrl) {
    fontLink.href = fontsUrl;
  }

  document.documentElement.style.setProperty('--font-body', fontStack(nextTypography.bodyFont));
  document.documentElement.style.setProperty('--font-heading', fontStack(nextTypography.headingFont));
  document.documentElement.style.setProperty('--font-accent', fontStack(nextTypography.accentFont));
};

const GlobalTypography = () => {
  const { settings } = useSettings();

  useEffect(() => {
    applyTypography(settings?.typography);
  }, [settings]);

  return null;
};

export default GlobalTypography;
